import React, { Component } from "react";
import { connect } from "react-redux";
import { crudGetOne, UserMenu, MenuItemLink } from "react-admin";
import SettingsIcon from "@material-ui/icons/Settings";

class UserMenuView extends Component {
  componentDidMount() {
    this.fetchProfile();
  }

  fetchProfile = () => {
    this.props.crudGetOne(
      // The resource
      "profile",
      // The id of the resource item to fetch
      localStorage.getItem("userId"),
      // The base path. Mainly used on failure to fetch the data
      "/profile",
      // Wether to refresh the current view. I don't need it here
      false
    );
  };

  render() {
    const { crudGetOne, profile, ...props } = this.props;
    return (
      <UserMenu label={profile ? profile.nickname : ""} {...props}>
        <MenuItemLink
          to={`/profile`}
          primaryText="Profile"
          leftIcon={<SettingsIcon />}
        />
      </UserMenu>
    );
  }
}

const mapStateToProps = (state) => {
  const resource = "profile";
  const id = localStorage.getItem("userId");
  return {
    profile: state.admin.resources[resource]
      ? state.admin.resources[resource].data[id]
      : null,
  };
};

const CustomUserMenu = connect(mapStateToProps, { crudGetOne })(UserMenuView);
export default CustomUserMenu;
